import removeInboxRuleRequest from 'owa-service/lib/factory/removeInboxRuleRequest';
import removeInboxRuleOperation from 'owa-service/lib/operation/removeInboxRuleOperation';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
/**
 * Helper method that creates the RemoveInboxRuleRequest body
 * @param inboxRule the inbox rule
 * @return RemoveInboxRuleRequest
 */
function createRequestBody(inboxRule, force, alwaysDeleteOutlookRulesBlob) {
    var requestBody = removeInboxRuleRequest({
        Header: getJsonRequestHeader(),
        Identity: inboxRule.Identity,
    });
    requestBody.Force = force;
    requestBody.AlwaysDeleteOutlookRulesBlob = alwaysDeleteOutlookRulesBlob;
    return requestBody;
}
/**
 * Remove inbox rule service
 * @param inboxRule the inbox rule
 * @return RemoveInboxRuleResponse
 */
export default function removeInboxRuleService(inboxRule, force, alwaysDeleteOutlookRulesBlob) {
    var requestBody = createRequestBody(inboxRule, force, alwaysDeleteOutlookRulesBlob);
    return removeInboxRuleOperation(requestBody);
}
//# sourceMappingURL=removeInboxRuleService.js.map